import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';

function Message({ variant, children ,dismissible}) {
    const [show, setShow] = useState(true);

    if (!show) return null;

    return (
        <Alert variant={variant} onClose={() => setShow(false)} dismissible={dismissible}>  
            {children}
        </Alert>
    );
}

export default Message;
